import { render, staticRenderFns } from "./ElectionParts.vue?vue&type=template&id=e8e3d018&scoped=true"
import script from "./ElectionParts.vue?vue&type=script&lang=js"
export * from "./ElectionParts.vue?vue&type=script&lang=js"
import style0 from "./ElectionParts.vue?vue&type=style&index=0&id=e8e3d018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e3d018",
  null
  
)

export default component.exports